export const TXTWCL_The_following_characters_are_n_ELL = {
  "id": "TXTWCL_The_following_characters_are_n_ELL",
  "defaultMessage": "The following characters are not valid: {0}"
} as const;